import fire from "./fire"
export default function askPermission () {
    return askForPermissionToReceiveNotifications ()
};
const askForPermissionToReceiveNotifications = async () => {
    if ("serviceWorker" in navigator && "PushManager") {
        try {
            const messaging = fire.messaging();
            await messaging.requestPermission().then(async function () {
                const token = await messaging.getToken();
            //console.log("token: ",token);
                localStorage.setItem("notification-token", token);
            });

           // return token;
        } catch(error) {
            console.error(error);
    }
}}